import { UseFormReturn } from "react-hook-form";
import { date } from "services";
import { tankaKbn } from "services/codes";
import { B000200Get } from "../b000/B000200";
import { B010010GetWhTanka } from "../b010/B010010";
import { catchRestError, RestClient } from "../RestClient";
import { B100140Jodaitanka } from "./B100140";

// 固定値
const whtankaKbnWh = "0";

export type B100130FindRequest = {
  setshohinCd: string;
};

export type B100130FindResponse = {
  gyoNo: number;
  shohinCd: string;
  shohinNm: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  jodaitanka: string;
  koseisu: string;
  tankaKbn: number;
  whtankaCd: string;
  crtDate: string;
  crtshainCd: string;
  version: string;
};

export const B100130Find = (props: B100130FindRequest) => {
  return RestClient.get<B100130FindResponse[]>("b100130/find", {
    params: props,
  });
};

export type B100130CreateRequest = {
  setshohinCd: string;
  // 明細
  b100130CreateMeiRequest: B100130CreateMeiRequest[];
  // 明細(削除対象のキー情報)
  b100130DeleteMeiRequest: B100130DeleteMeiRequest[];
} & Partial<{}>;

export type B100130CreateMeiRequest = {
  gyoNo: number;
  shohinCd: string;
  koseisu: string;
} & Partial<{
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  jodaitanka: string;
  crtDate: string;
  crtshainCd: string;
  version: string;
}>;

export type B100130DeleteMeiRequest = {} & Partial<{
  gyoNo: number;
  shohinCd: string;
  version: string;
}>;

// 登録処理
export const B100130Create = (data: B100130CreateRequest) => {
  return RestClient.post("b100130/create", data);
};

// 商品変更メソッド
export const B100130HandleChangeShohinCd = async (
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const meiFields = meiMethods.getValues();
  if (meiFields.shohinCd === "") {
    // 項目をクリア
    meiMethods.setValue("shohinNm", "");
    meiMethods.setValue("jodaitanka", "");
    meiMethods.setValue("tankaKbn", "");
    meiMethods.setValue("whtankaCd", "");
    return;
  }

  await B000200Get({ shohinCd: meiFields.shohinCd })
    .then((response) => {
      meiMethods.setValue("shohinNm", response.data.shohinNm ?? "");
      meiMethods.setValue("tankaKbn", response.data.tankaKbn ?? "");
      meiMethods.setValue("whtankaCd", response.data.whtankaCd ?? "");
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      // 項目をクリア
      meiMethods.setValue("shohinNm", "");
      meiMethods.setValue("jodaitanka", "");
      meiMethods.setValue("tankaKbn", "");
      meiMethods.setValue("whtankaCd", "");

      catchRestError(reason, navigate, setMsg);
    });
  // 商品関連項目設定処理メソッド
  await B100130Shohin(meiMethods, navigate, setMsg);
};

// 商品関連項目設定処理
export const B100130Shohin = async (
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const meiFields = meiMethods.getValues();

  // 単価区分「0:通常」の場合
  if (meiFields.tankaKbn === tankaKbn.tujo) {
    // 単価を取得
    B100140Jodaitanka(meiMethods, tankaKbn.tujo, date(), navigate, setMsg);
  }
  // 単価区分「1:WH」の場合
  else if (meiFields.tankaKbn === tankaKbn.wh) {
    // WH単価を取得
    B100130WhTanka(meiMethods, navigate, setMsg);
  }
};

//WH単価取得処理メソッド
export const B100130WhTanka = async (
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const meiFields = meiMethods.getValues();

  // 単価区分「0:通常」の場合、何もしない
  if (meiFields.tankaKbn === tankaKbn.tujo) return;

  // 入力済みではない場合
  if (
    meiFields.whtankaCd === "" ||
    meiFields.sotosunH === "" ||
    meiFields.sotosunW === ""
  )
    return;

  await B010010GetWhTanka({
    whtankaKbn: whtankaKbnWh,
    whtankaCd: meiFields.whtankaCd,
    height: meiFields.sotosunH,
    width: meiFields.sotosunW,
  })
    .then((response) => {
      // 上代単価
      meiMethods.setValue("jodaitanka", response.data.tanka ?? "");
    })
    .catch((reason) => {
      // WH単価取得の返却値が存在しない場合、ここに入る
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("jodaitanka", "");
    });
};
